import { useEffect, useState } from 'react'
import { postPortaria } from './portariaApi'

export function FacialPhoto({ clientId, personId, name, thumbnail = false }: { clientId: string; personId: string; name: string; thumbnail?: boolean }) {
  const [open, setOpen] = useState(false)
  const [photo, setPhoto] = useState<string | null>(null)
  const [message, setMessage] = useState('')
  useEffect(() => {
    if (!open && !thumbnail) return
    let cancelled = false
    let timer: ReturnType<typeof setTimeout>
    const deadline = Date.now() + 90000
    setPhoto(null)
    setMessage('Carregando a foto facial…')
    const load = async () => {
      try {
        const result = await postPortaria<{ status: string; photoBase64?: string }>(clientId, `people/${personId}/face-photo`)
        if (cancelled) return
        if (result.status === 'succeeded' && result.photoBase64) {
          setPhoto(`data:image/jpeg;base64,${result.photoBase64}`)
          setMessage('')
        } else if (result.status === 'failed' || Date.now() >= deadline) {
          setMessage('Não foi possível obter a foto. Confira se o agente facial está conectado e tente novamente.')
        } else timer = setTimeout(() => void load(), 3000)
      } catch {
        if (!cancelled) setMessage('Foto indisponível. A pessoa precisa ter um cadastro facial vinculado à Spectra e o agente deve estar conectado.')
      }
    }
    void load()
    return () => { cancelled = true; clearTimeout(timer) }
  }, [open, thumbnail, clientId, personId])
  return <>
    <button type="button" onClick={() => setOpen(true)}>{thumbnail && photo ? <img src={photo} alt={`Foto de ${name}`} style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8 }} /> : 'Ver foto facial'}</button>
    {open && <div role="dialog" aria-modal="true" aria-label={`Foto facial de ${name}`} style={{ position: 'fixed', inset: 0, zIndex: 1000, background: '#001b35bb', display: 'grid', placeItems: 'center', padding: 16 }} onClick={() => setOpen(false)}>
      <div className="portaria-card" style={{ width: 'min(100%, 440px)', maxHeight: '90vh', overflow: 'auto' }} onClick={event => event.stopPropagation()}>
        <h3>{name}</h3>
        {photo ? <img src={photo} alt={`Foto facial de ${name}`} style={{ display: 'block', maxWidth: '100%', maxHeight: '60vh', margin: '0 auto', objectFit: 'contain' }} /> : <p role="status">{message}</p>}
        <button type="button" onClick={() => { setPhoto(null); setOpen(false) }}>Fechar</button>
      </div>
    </div>}
  </>
}
